import { parser, RuleType, type MarkdownToJSX } from "markdown-to-jsx";
import { formatDateShort } from "../../lib/formatTimestamp";

function plainText(nodes: MarkdownToJSX.ASTNode[]): string {
  return nodes
    .map((node) => {
      if (node.type === RuleType.text || node.type === RuleType.codeInline)
        return node.text;
      if ("children" in node && Array.isArray(node.children)) {
        const text = plainText(node.children);
        return node.type === RuleType.paragraph ||
          node.type === RuleType.heading
          ? `${text} `
          : text;
      }
      if (
        node.type === RuleType.unorderedList ||
        node.type === RuleType.orderedList
      )
        return node.items.map(plainText).join(" ");
      return "";
    })
    .join("");
}

export function researchSourcePreview(markdown: string | undefined): string {
  if (!markdown) return "";
  const text = plainText(parser(markdown)).replace(/\s+/g, " ").trim();
  if (text.length <= 240) return text;
  const end = text.lastIndexOf(" ", 240);
  return `${text.slice(0, end > 0 ? end : 240)}…`;
}

export function researchSourceDate(
  value: string | undefined,
  now: number
): string {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "";
  const today = new Date(now);
  if (date.toDateString() === today.toDateString()) return "Today";
  return formatDateShort(date.getTime());
}
